
<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent min-width="300px"  max-width="600px">
      <!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
      <v-card>
        <v-card-title>
          <span class="headline">Actions</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs2 offset-xs4>
                <v-btn outline large @click="transfer = true" flat><v-icon light large left>swap_horiz</v-icon>Send</v-btn>
               <!--  <v-btn large @click="issue = true" flat><v-icon large left>account_circle</v-icon>Issue</v-btn>
                <v-btn large @click="create = true" flat><v-icon large left>account_circle</v-icon>Create</v-btn> -->
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <TransferToken v-on:closeDialog="closeActionDialog()" :dialogg="true" v-if="transfer"></TransferToken>
              <!-- <IssueToken v-on:closeDialog="closeActionDialog()" v-if="issue"></IssueToken>
              <CreateToken v-on:closeDialog="closeActionDialog()" v-if="create"></CreateToken> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>

</template>

<script>
  import TransferToken from './TransferToken'
  import IssueToken from './IssueToken'
  import CreateToken from './CreateToken'
  export default {
    components: {
      TransferToken,
      IssueToken,
      CreateToken
    },
    props: {
      dialogg: Boolean
    },
    watch: {
      dialogg () {
        this.dialog = this.dialogg
      }
    },
    methods: {
      closeDialog(event) {
        this.$emit('closeActionDialog', event)
      },
      closeActionDialog: function () {
        this.create = false,
        this.issue = false,
        this.transfer = false
      },
    },
    data () {
      return {
        dialog: true,
        create: false,
        issue: false,
        transfer: false
      }
    }
  }
</script>